import React, { Component } from 'react'
import { DatePicker, Modal, Tooltip } from 'antd'
import cx from 'classnames'
import moment from 'moment'
import _ from 'lodash'

import './PaymentBlock.scss'

export default class PaymentBlock extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // visibleList: new Array(paymentList.length).fill(false)
            paidDateList: []
        }
    }

    // handleVisibleChange(idx, checked, disabled, visible) {
    //     let { visibleList } = this.state

    //     if (checked || disabled) {
    //         visibleList[idx] = false
    //         this.setState({ visibleList })
    //     } else {
    //         visibleList[idx] = visible
    //         this.setState({ visibleList })
    //     }
    // }

    handlePaidDateChange(idx, date, dateString) {
        const { paidDateList } = this.state
        let newPaidDateList = _.cloneDeep(paidDateList)

        newPaidDateList[idx] = date

        this.setState({ paidDateList: newPaidDateList })
    }

    getBlockClassname(paid, disabled) {
        return cx('block', {
            'active': paid,
            'disabled': disabled
        })
    }

    componentDidUpdate(prevProps, prevState) {
        const { fieldName, paymentList } = this.props

        if (fieldName === 'paid' && prevProps.paymentList !== paymentList && prevProps.paymentList.length === 0) {
            this.setState({ paidDateList: new Array(paymentList.length).fill(moment()) })
        }
    }

    componentDidMount() {
        const { fieldName, paymentList } = this.props
        if (fieldName === 'paid') {
            this.setState({ paidDateList: new Array(paymentList.length).fill(moment()) })
        }
    }

    renderBlock() {
        const { onClick, paymentList, fieldName } = this.props
        // const { visibleList } = this.state

        return _.map(paymentList, (payment, idx) => {
            const disabled = this.props.disabled || (fieldName === 'paid' && !payment.invoice_sent) || (fieldName === 'invoice_sent' && !payment.invoice_exported)
            const popConfirmMessage = fieldName !== 'paid' ?
                'This action is irreversible, are you sure?' :
                (
                    <div>
                        <p>This action is irreversible, are you sure?</p>
                        <span>Paid at: </span>
                        <DatePicker
                            defaultValue={moment()}
                            onChange={(date, dateString) => this.handlePaidDateChange(idx, date, dateString)}
                        />
                    </div>
                )

            return <Tooltip placement="top" title={payment.name} key={`${payment.name}-${idx}`}>
                        <div 
                            key={idx} 
                            className={this.getBlockClassname(payment[fieldName], disabled)} 
                            onClick={(e) => {
                                if (!disabled && !payment[fieldName])
                                    return Modal.confirm({
                                        title: 'Confirm',
                                        content: popConfirmMessage,
                                        okText: 'Yes',
                                        onOk: () => onClick(idx, payment[fieldName], this.state.paidDateList[idx]),
                                        onCancel: () => {}
                                    })
                                }
                            }
                        />
                    </Tooltip>
        })
    }

    render() {
        const { paymentList } = this.props

        return (
            <div className="PaymentBlock">
                {paymentList.length > 0 ? this.renderBlock() : 'N/A'}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/PaymentBlock/PaymentBlock.js